export const FETCH_USERS_DOSSIERS_REQUEST = 'FETCH_USERS_DOSSIERS_REQUEST';
export const FETCH_USERS_DOSSIERS_SUCCESS = 'FETCH_USERS_DOSSIERS_SUCCESS';
export const FETCH_USERS_DOSSIERS_FAILURE = 'FETCH_USERS_DOSSIERS_FAILURE';


export const FETCH_PARTNERS_DOSSIERS_REQUEST = 'FETCH_PARTNERS_DOSSIERS_REQUEST';
export const FETCH_PARTNERS_DOSSIERS_SUCCESS = 'FETCH_PARTNERS_DOSSIERS_SUCCESS';
export const FETCH_PARTNERS_DOSSIERS_FAILURE = 'FETCH_PARTNERS_DOSSIERS_FAILURE';

export const SET_DOSSIER_FILTER = 'SET_DOSSIER_FILTER';


